import { actionTypes } from 'store/utils';

export const types = {
  ...actionTypes('SET_XEMD_DETAILS'),
  ...actionTypes('CLEAR_XEMD_DETAILS'),
  SET_ACTIVE_FORM_ID: 'SET_ACTIVE_FORM_ID',
}